// extracted by mini-css-extract-plugin
export default {"card":"styles_card__RiBZM","item":"styles_item__EB3It","active":"styles_active__-roV8"};